import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { Faqs } from 'components/Faqs';
import { faq } from 'sections/Benefits/data';
import styles from 'sections/Benefits/components/SectionFaq/SectionFaq.module.scss';

const cn = classNames.bind(styles);

const SectionFaq = (): ReactElement => {
  return (
    <section className={cn('faqs')}>
      <div className={cn('container')}>
        <h2 className={cn('faqs__title')}>Frequently Asked Questions</h2>
        <div className={cn('faqs__container')}>
          <Faqs faqsData={faq} />
        </div>
      </div>
    </section>
  );
};

export default SectionFaq;